import React from 'react';
import NavBadge from './NavBadge';
import useAccountantOutstanding from '../../hooks/useAccountantOutstanding';

// item 482 — the Accountant nav badge: outstanding count (red pill) or a green check once the
// dashboard is all caught up. Mounts only on the accountant tool row (admin/accountant), so its
// queries never run for users who can't see the tool.
const AccountantNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { total, caughtUp, loaded } = useAccountantOutstanding();
  if (!loaded) return null;
  return <NavBadge count={total} caughtUp={caughtUp} collapsed={collapsed} />;
};

AccountantNavBadge.defaultProps = { collapsed: false };

export default AccountantNavBadge;
